/**
 * Cache updaters for a table's field rules.
 *
 * Hand-typed because the generated schema cannot describe them:
 * `Field_RulesResponseFieldRule` resolves to `unknown`, since the endpoint is
 * polymorphic over rule type and drf-spectacular has nothing to narrow it with.
 * Only the identity is needed here -- the rule body is opaque to this layer and
 * belongs to whatever renders it.
 */
export interface FieldRule {
  id: number
  table_id: number
  [key: string]: unknown
}

export function addFieldRule(rules: FieldRule[], rule: FieldRule): FieldRule[] {
  const index = rules.findIndex((existing) => existing.id === rule.id)
  if (index === -1) return [...rules, rule]

  const next = [...rules]
  next[index] = rule
  return next
}

export function updateFieldRule(rules: FieldRule[], rule: FieldRule): FieldRule[] {
  const index = rules.findIndex((existing) => existing.id === rule.id)
  if (index === -1) return rules

  const next = [...rules]
  next[index] = { ...rules[index]!, ...rule }
  return next
}

export function removeFieldRule(rules: FieldRule[], ruleId: number): FieldRule[] {
  const next = rules.filter((rule) => rule.id !== ruleId)
  return next.length === rules.length ? rules : next
}
